<div nz-row [nzGutter]="[0, 32]" nzJustify="center">
  <div nz-col nzSpan="24">
    <form nz-form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div nz-row nzAlign="middle" [nzGutter]="[hGutter, 32]">
        <div
          nz-col
          id="login-form"
          nzFlex="1"
        >
          <div nz-row [nzGutter]="[hGutter, 16]">
            <div
              nz-col
              nzSpan="24"
            >
              <p> Inserisci le credenziali del tuo account <b>TSiD abilitato SPID</b></p>
            </div>
            <div nz-col nzSpan="24">
              <div nz-row [nzGutter]="[0, 8]">
                <div nz-col nzSpan="24">
                  <nz-form-item>
                    <nz-form-control [nzErrorTip]="getValidationErrorMessage('username')">
                      <nz-input-group
                        nzPrefixIcon="user" class="login">
                        <input
                          appAutoFocus
                          type="text" nz-input formControlName="username" tabindex="1"
                          i18n-placeholder="Auth.Generic.PlaceholderUsername|placeholder for username in form@@Auth.Generic.PlaceholderUsername"
                          placeholder="Username"/>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col nzSpan="24">
                  <a
                    class="custom-form-forgot" [routerLink]="getAppPaths('username')"
                    i18n="Auth.Login.ForgottenUsername|link to recovery username@@Auth.Login.ForgottenUsername">
                    Hai dimenticato il tuo username?
                  </a>
                </div>
              </div>
            </div>
            <div nz-col nzSpan="24">
              <div nz-row [nzGutter]="[0, 8]">
                <div nz-col nzSpan="24">
                  <nz-form-item>
                    <nz-form-control [nzErrorTip]="getValidationErrorMessage('password')">
                      <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="passwordTemplate">
                        <input
                          tabindex="2" [type]="passwordVisible ? 'text' : 'password'" nz-input
                          formControlName="password"
                          i18n-placeholder="Auth.Generic.PlaceholderPassword|placeholder for password in form@@Auth.Generic.PlaceholderPassword"
                          placeholder="Password"/>
                      </nz-input-group>
                      <ng-template #passwordTemplate>
                        <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                           (click)="passwordVisible = !passwordVisible"></i>
                      </ng-template>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col nzSpan="24">
                  <a tabindex="3" class="custom-form-forgot" [routerLink]="getAppPaths('password')"
                     i18n="Auth.Login.ForgottenPassword|link to recovery password@@Auth.Login.ForgottenPassword">
                    Hai dimenticato la password?
                  </a>
                </div>
              </div>
            </div>
            <div nz-col nzSpan="24">
              <button
                nz-button
                nzType="primary"
                i18n="@@UsernamePassword.Login.Text"
                [disabled]="form.invalid"
                class="login"
              >
                Accedi
              </button>
            </div>
          </div>
        </div>
        <div
          nz-col
          *ngIf="showAuthenticationWithApp"
        >
          <nz-divider class="vertical" nzType="vertical"></nz-divider>
          <nz-divider class="horizontal" nzType="horizontal"></nz-divider>
        </div>
        <div
          nz-col
          nzFlex="1"
          *ngIf="showAuthenticationWithApp"
        >
          <div nz-row [nzGutter]="[0, 8]">
            <div nz-col nzSpan="24">
              <app-qr-code
                [qrCode]="autoLoginQrCode$ | async"
              ></app-qr-code>
            </div>
            <div nz-col>
              <p class="qrcode-description">Inquadra li QR CODE con l'app <a href="http://google.com/TODO">TSiD abilitato
                SPID</a> per accedere rapidamente</p>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div nz-col>
    <p
      i18n="@@UsernamePassword.RequireASPID.Text"
      class="text-center"
    >Non hai ancora il TSiD abilitato SPID? <a href="https://www.teamsystem.com/store/ts-spid/privati/">Richiedilo</a></p>
  </div>
</div>
